export default "__VITE_ASSET__COVfmksZ__"